import { render, staticRenderFns } from "./ComponentMechanismDetail.vue?vue&type=template&id=c28aed12&scoped=true"
import script from "./ComponentMechanismDetail.vue?vue&type=script&lang=js"
export * from "./ComponentMechanismDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28aed12",
  null
  
)

export default component.exports